module.exports = __webpack_public_path__ + "img/kid_second-mobile.5791822f.svg";